// extracted by mini-css-extract-plugin
export default {"container":"Banner_container__-P8uy","title":"Banner_title__zUAp0","spinner":"Banner_spinner__iKpaz"};